import {Injectable, TemplateRef} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdminValetService } from 'src/app/admin/modules/admin-valet/services/admin-valet.service';
import { LinkDisplayColumnComponent } from 'src/app/shared/components/link-display-column/link-display-column.component';
import { FilterConfig } from 'src/app/shared/models/filter-config.interface';
import { BackendFilteringObject, GridColumnConfig } from 'src/app/shared/models/grid-config.interface';

@Injectable({
  providedIn: 'root'
})
export class CommonValetInvoicesConfig {

  public static readonly FILTER_KEYS = {
    VALET_ID: 'valetId',
  } as const;

  public static readonly ALL_FILTER_KEYS = Object.values(CommonValetInvoicesConfig.FILTER_KEYS);

  constructor(
    private translateService: TranslateService) {}

  public getCommonValetInvoicesColumnConfig(
    dateTemplate?: TemplateRef<LinkDisplayColumnComponent>,
    amountTemplate?: TemplateRef<LinkDisplayColumnComponent>,
    fileTemplate?: TemplateRef<LinkDisplayColumnComponent>): GridColumnConfig[] {
    const columns: GridColumnConfig[] = [];

    if (dateTemplate) {
      columns.push({
          key: 'date',
          label: this.translateService.instant('modules.valet.valet_invoices.grid.date'),
          type: 'custom',
          template: dateTemplate,
          sort: true,
          filter: true
        },
      );
    }

    columns.push({
        key: 'invoiceReference',
        label: this.translateService.instant('modules.valet.valet_invoices.grid.invoice_reference'),
        type: 'string',
        sort: true,
        filter: true
      },
    );

    columns.push({
        key: 'paymentReference',
        label: this.translateService.instant('modules.valet.valet_invoices.grid.payment_reference'),
        type: 'string',
        sort: true,
        filter: true
      },
    );

    if (amountTemplate) {
      columns.push({
          key: 'amount',
          label: this.translateService.instant('modules.valet.valet_invoices.grid.amount'),
          type: 'custom',
          template: amountTemplate,
          sort: true,
          filter: true
        },
      );
    }

    if (fileTemplate) {
      columns.push({
          key: 'file',
          label: this.translateService.instant('modules.valet.valet_invoices.grid.pdf'),
          type: 'custom',
          template: fileTemplate,
          sort: true,
          filter: true
        },
      );
    }

    return columns;
  }

  getFilterKeys(): string[] {
      return Object.values(CommonValetInvoicesConfig.FILTER_KEYS);
    }
  
    getFilterKeyMapping(): { [key: string]: string } {
      const mapping: { [key: string]: string } = {};
      this.getFilterKeys().forEach(key => {
        mapping[key] = key;
      });
      return mapping;
    }
  
    public getFiltersConfig(): FilterConfig[] {
      return [];
    }

  public createGridConfig(
    filtersStorageKey: string,
    sortStorageKey: string,
    adminValetService: AdminValetService,
    router: any,
    activeRoute: any,
    valetId: string
  ) {
    return {
      entityName: 'CommonValetInvoicesGrid',
      storageKeys: {
        filters: filtersStorageKey,
        sort: sortStorageKey,
      },
      autoLoad: true,
      filterFields: {
        valetId: {
          backendField: 'valetId',
          persistent: true
        }
      },
      apiService: {
        getData: (filterObj: BackendFilteringObject) => {
          return adminValetService.getValetInvoices(valetId, filterObj);
        },
        exportPageData: (data) => adminValetService.exportValetInvoicesPageData(data)
      },
      routerDependencies: {
        router: router,
        activatedRoute: activeRoute
      }
    };
  }
}
